import React from 'react'

function useQueryParam(name: string) {
  const [val, setVal] = React.useState<string | null>(null)
  React.useEffect(() => {
    try {
      const u = new URL(window.location.href)
      setVal(u.searchParams.get(name))
    } catch {}
  }, [name])
  return val
}

export default function ReauthStartPage() {
  const token = useQueryParam('token')
  const auto = useQueryParam('auto')
  const [state, setState] = React.useState<'loading' | 'ready' | 'error'>('loading')
  const [error, setError] = React.useState<string>('')
  const [meta, setMeta] = React.useState<{ email: string; provider: 'google' | 'microsoft'; authPath: string; callbackUrl: string; auto: boolean } | null>(null)
  const formRef = React.useRef<HTMLFormElement>(null)
  const csrfRef = React.useRef<HTMLInputElement>(null)

  React.useEffect(() => {
    (async () => {
      if (!token) return
      try {
        const res = await fetch(`/reauth/meta?token=${encodeURIComponent(token)}`, { credentials: 'include', headers: { accept: 'application/json' } })
        if (!res.ok) {
          throw new Error(String(res.status))
        }
        const data = await res.json()
        setMeta(data)
        setState('ready')
      } catch (err: any) {
        setError('A link lejárt vagy érvénytelen. Kérj új meghívót az adminisztrátortól.')
        setState('error')
      }
    })()
  }, [token])

  async function ensureCsrf() {
    try {
      const res = await fetch('/auth/csrf', { credentials: 'include', headers: { accept: 'application/json' } })
      if (res.ok) {
        const data = await res.json()
        if (csrfRef.current && data && data.csrfToken) csrfRef.current.value = data.csrfToken
      }
    } catch {}
  }

  React.useEffect(() => {
    (async () => {
      if (state !== 'ready' || !meta) return
      await ensureCsrf()
      const shouldAuto = (auto === '1' || auto === 'true') || Boolean(meta.auto)
      if (shouldAuto && formRef.current) {
        try { formRef.current.submit() } catch {}
      }
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state, meta])

  if (state === 'loading') {
    return (
      <div className="flex min-h-[40vh] items-center justify-center text-muted-foreground">Betöltés…</div>
    )
  }
  if (state === 'error' || !meta) {
    return (
      <div className="flex min-h-[60vh] items-center justify-center">
        <div className="max-w-md rounded-lg border bg-card p-6 text-center text-card-foreground shadow">
          <h1 className="text-xl font-semibold">Link lejárt</h1>
          <p className="mt-2 text-sm text-muted-foreground">{error}</p>
        </div>
      </div>
    )
  }

  const isMs = meta.provider === 'microsoft'
  return (
    <div className="flex min-h-[60vh] items-center justify-center">
      <div className="w-full max-w-lg rounded-lg border bg-card p-6 text-card-foreground shadow">
        <h1 className="text-xl font-semibold">
          {isMs ? 'Microsoft hozzáférés megerősítése' : 'Gmail hozzáférés megerősítése'}
        </h1>
        <p className="mt-2 text-sm text-muted-foreground">
          Csatlakoztatni készülsz a(z) <code className="rounded bg-muted px-1 py-0.5">{meta.email}</code> postafiókot az Email Sync rendszerhez.
        </p>
        <form ref={formRef} method="POST" action={meta.authPath} className="mt-4 space-y-3">
          <input type="hidden" name="callbackUrl" value={meta.callbackUrl} />
          <input ref={csrfRef} type="hidden" name="csrfToken" value="" />
          <button
            type="submit"
            className="inline-flex items-center rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground transition-colors hover:opacity-90"
            title={isMs ? 'Folytatás Microsoft bejelentkezéssel' : 'Folytatás Google bejelentkezéssel'}
          >
            Folytatás {isMs ? 'Microsoft' : 'Google'} bejelentkezéssel
          </button>
        </form>
        <p className="mt-2 text-xs text-muted-foreground">
          Ha a gomb nem működik, a folyamat automatikusan megpróbál indulni. Ha nem sikerül, kattints a gombra újra.
        </p>
      </div>
    </div>
  )
}

